const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i
const PERSON_NAME_RE = /^[\p{L}][\p{L}\p{M}.'\- ]*$/u
const BUSINESS_NAME_RE = /^[\p{L}\p{N}][\p{L}\p{N} .,&'()/#\-]*$/u
const IN_PHONE_RE = /^[6-9]\d{9}$/
const US_PHONE_RE = /^[2-9]\d{2}[2-9]\d{6}$/

function normalizeText(value) {
  return (value || '').toString().trim()
}

export function normalizeEmail(value) {
  return normalizeText(value).toLowerCase()
}

export function validateEmail(value) {
  const email = normalizeEmail(value)
  return email.length > 0 && EMAIL_RE.test(email)
}

export function validatePersonName(value, { required = true, min = 2, max = 60 } = {}) {
  const text = normalizeText(value)
  if (!text) return !required
  if (text.length < min || text.length > max) return false
  return PERSON_NAME_RE.test(text)
}

export function validateBusinessName(value, { required = true, min = 2, max = 100 } = {}) {
  const text = normalizeText(value)
  if (!text) return !required
  if (text.length < min || text.length > max) return false
  return BUSINESS_NAME_RE.test(text)
}

export function validateAddress(value, { required = true, min = 5, max = 200 } = {}) {
  const text = normalizeText(value)
  if (!text) return !required
  return text.length >= min && text.length <= max
}

export function detectPhoneRegion() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
    if (timeZone === 'Asia/Kolkata' || timeZone === 'Asia/Calcutta') return 'IN'
    const language = (navigator.language || '').toLowerCase()
    if (language === 'en-in' || language.startsWith('hi') || language.startsWith('ta') || language.startsWith('te') || language.startsWith('mr')) {
      return 'IN'
    }
  } catch (e) {
    // ignore environment detection failures
  }
  return 'US'
}

export const PHONE_REGIONS = [
  { value: 'IN', label: 'India (+91)', example: '+91 98765 43210' },
  { value: 'US', label: 'USA (+1)', example: '+1 212 555 0100' },
]

export function getPhoneRegionLabel(region = detectPhoneRegion()) {
  return PHONE_REGIONS.find((item) => item.value === region)?.label || PHONE_REGIONS[1].label
}

export function getPhonePrefix(region = detectPhoneRegion()) {
  return region === 'IN' ? '+91 ' : '+1 '
}

export function getPhoneExample(region = detectPhoneRegion()) {
  return PHONE_REGIONS.find((item) => item.value === region)?.example || PHONE_REGIONS[1].example
}

function compactPhone(value) {
  return normalizeText(value).replace(/[\s().-]/g, '')
}

export function normalizePhone(value, region = detectPhoneRegion()) {
  const compact = compactPhone(value)
  if (!compact) return ''

  if (compact.startsWith('+91')) {
    const local = compact.slice(3)
    return IN_PHONE_RE.test(local) ? `+91${local}` : ''
  }

  if (compact.startsWith('+1')) {
    const local = compact.slice(2)
    return US_PHONE_RE.test(local) ? `+1${local}` : ''
  }

  const digitsOnly = compact.replace(/\D/g, '')
  if (region === 'IN') {
    return IN_PHONE_RE.test(digitsOnly) ? `+91${digitsOnly}` : ''
  }

  return US_PHONE_RE.test(digitsOnly) ? `+1${digitsOnly}` : ''
}

export function validatePhone(value, region = detectPhoneRegion()) {
  return normalizePhone(value, region) !== ''
}

export function getPhoneValidationMessage(region = detectPhoneRegion()) {
  return region === 'IN'
    ? 'Enter a valid Indian phone number, for example +91 98765 43210'
    : 'Enter a valid US phone number, for example +1 212 555 0100'
}